import React, { Suspense, lazy } from 'react';
import './productSlider.scss';

import classNames from "classnames";
import {connect} from 'react-redux';
import ContainerDimensions from 'react-container-dimensions'

import Page from '../Page';
//import UploadModal from './UploadModal';

import {goPreviewPage, instantUpload} from '../../actions';

const UploadModal = lazy(() => import('./UploadModal'));

class ProductSlider extends React.PureComponent {

    handlePageClick(index) {
        this.props.goPreviewPage(index);
        return false;
    }

    render() {
        return <ContainerDimensions key="product-slider">
            {({width}) => {
                let containerWidth = width;
                // let containerHeight = height;
                let bigPreviewSize = {
                    width: containerWidth,
                    height: containerWidth,
                };
                let smallPreviewSize = {
                    width: containerWidth / 7 + 4,
                    height: containerWidth / 7 + 4,
                };
                let currentDesignBackground = this.props.currentDesignBackground && this.props.currentDesignBackground.previews && this.props.currentDesignBackground.previews[this.props.previewPage] ? this.props.currentDesignBackground.previews[this.props.previewPage] : null;
                let printingWidth = currentDesignBackground ? currentDesignBackground.design_canvas_location.width : 0;
                let printingHeight = currentDesignBackground ? currentDesignBackground.design_canvas_location.height : 0;
                //let designPageIdx = currentDesignBackground && currentDesignBackground.design_page && this.props.pages[currentDesignBackground.design_page] ? currentDesignBackground.design_page : this.props.previewPage
                let designPageIdx = currentDesignBackground && currentDesignBackground.design_page && this.props.pages[currentDesignBackground.design_page] ? currentDesignBackground.design_page : 0;
                if (isNaN(designPageIdx)) {
                    designPageIdx = 0;
                }
                let printingZoom = 1;
                let productBackgroundSize = 0;
                if (printingWidth !== 0 && printingHeight !== 0 && this.props.pages && this.props.pages.length) {
                    if (this.props.pages[designPageIdx].width / printingWidth > this.props.pages[designPageIdx].height / printingHeight) {
                        printingZoom = this.props.pages[designPageIdx].width / printingWidth;
                        productBackgroundSize = currentDesignBackground.design_background_width;
                    } else {
                        printingZoom = this.props.pages[designPageIdx].height / printingHeight;
                        productBackgroundSize = currentDesignBackground.design_background_height;
                    }
                }
                let zoomScale = containerWidth / productBackgroundSize / printingZoom;
                let designBackgroundStyle = {position: 'absolute'};
                //let smallDesignBackgroundStyle = {position: 'absolute'};

                let backgroundOffsetLeft = 0;
                let backgroundOffsetTop = 0;
                if (currentDesignBackground) {
                    if (currentDesignBackground.design_background_width > currentDesignBackground.design_background_height) {
                        backgroundOffsetLeft = -(currentDesignBackground.design_background_width - currentDesignBackground.design_background_height) / 2;
                    } else {
                        backgroundOffsetTop = -(currentDesignBackground.design_background_height - currentDesignBackground.design_background_width) / 2;
                    }
                }
                designBackgroundStyle.top = currentDesignBackground ? ((backgroundOffsetTop + currentDesignBackground.design_canvas_location.top) * printingZoom * zoomScale) : 0;
                designBackgroundStyle.left = currentDesignBackground ? ((backgroundOffsetLeft + currentDesignBackground.design_canvas_location.left) * printingZoom * zoomScale) : 0;
                // console.log(
                //     this.props.currentDesignBackground,
                //     this.props.currentDesignBackground && this.props.currentDesignBackground.previews && this.props.currentDesignBackground.previews[this.props.previewPage] ? this.props.currentDesignBackground.previews[this.props.previewPage] : null)
                return (<div>
                    <div>{currentDesignBackground ? (<div className="project_preview_content" style={bigPreviewSize}>
                        <div style={designBackgroundStyle}>
                            {/* eslint-disable-next-line */}
                            <Page
                                instantUpload={currentDesignBackground.design_page == this.props.previewPage ? this.props.instantUpload : null}
                                isProductSlider={true}
                                key={"big_preview_" + this.props.previewPage}
                                data={this.props.pages[designPageIdx]}
                                containerId="preview-container"
                                previewOnly={true}
                                currentDesignBackground={this.props.currentDesignBackground && this.props.currentDesignBackground.previews && this.props.currentDesignBackground.previews[this.props.previewPage] ? this.props.currentDesignBackground.previews[this.props.previewPage] : null}
                                idx={designPageIdx}
                                no_side={true}
                                zoomScale={zoomScale}
                            />
                        </div>
                    </div>) : null}</div>
                    <div className="row">
                        <div className="row pl-3 pt-3">
                            <div className="col">
                                {(this.props.currentDesignBackground && this.props.currentDesignBackground.previews) ? (this.props.currentDesignBackground.previews.map((preview, index) => {
                                    if (!this.props.pages) return null;
                                    let currentDesignBackground = this.props.currentDesignBackground && this.props.currentDesignBackground.previews && this.props.currentDesignBackground.previews[index] ? this.props.currentDesignBackground.previews[index] : null;
                                    let printingWidth = currentDesignBackground ? currentDesignBackground.design_canvas_location.width : 0;
                                    let printingHeight = currentDesignBackground ? currentDesignBackground.design_canvas_location.height : 0;
                                    let designPageIdx = currentDesignBackground && currentDesignBackground.design_page && this.props.pages[currentDesignBackground.design_page] ? currentDesignBackground.design_page : 0;
                                    let printingZoom = 1;
                                    let productBackgroundSize = 0;
                                    if (printingWidth !== 0 && printingHeight !== 0 && this.props.pages && this.props.pages.length) {
                                        if (this.props.pages[designPageIdx].width / printingWidth > this.props.pages[designPageIdx].height / printingHeight) {
                                            printingZoom = this.props.pages[designPageIdx].width / printingWidth;
                                            productBackgroundSize = currentDesignBackground.design_background_width;
                                        } else {
                                            printingZoom = this.props.pages[designPageIdx].height / printingHeight;
                                            productBackgroundSize = currentDesignBackground.design_background_height;
                                        }
                                    }
                                    let zoomScale = containerWidth / 7 / productBackgroundSize / printingZoom;
                                    let designBackgroundStyle = {position: 'absolute', zIndex: -1};
                                    designBackgroundStyle.top = currentDesignBackground ? (currentDesignBackground.design_canvas_location.top * printingZoom * zoomScale) : 0;
                                    designBackgroundStyle.left = currentDesignBackground ? (currentDesignBackground.design_canvas_location.left * printingZoom * zoomScale) : 0;

                                    if (currentDesignBackground) {
                                        if (currentDesignBackground.design_background_width > currentDesignBackground.design_background_height) {
                                            backgroundOffsetLeft = -(currentDesignBackground.design_background_width - currentDesignBackground.design_background_height) / 2;
                                        } else {
                                            backgroundOffsetTop = -(currentDesignBackground.design_background_height - currentDesignBackground.design_background_width) / 2;
                                        }
                                    }
                                    designBackgroundStyle.top = currentDesignBackground ? ((backgroundOffsetTop + currentDesignBackground.design_canvas_location.top) * printingZoom * zoomScale) : 0;
                                    designBackgroundStyle.left = currentDesignBackground ? ((backgroundOffsetLeft + currentDesignBackground.design_canvas_location.left) * printingZoom * zoomScale) : 0;

                                    return (<div key={"product_detail_slider_" + index}
                                                 className={classNames("project_preview_content slider-preview", {"option_selected": index === this.props.previewPage})}
                                                 style={smallPreviewSize}
                                                 onClick={this.handlePageClick.bind(this, index)}>
                                        <div style={designBackgroundStyle}>
                                            <Page
                                                recalculateFont={false}
                                                key={"small_preview_" + this.props.pages.hash}
                                                data={this.props.pages[designPageIdx]}
                                                containerId="preview-container"
                                                previewOnly={true}
                                                isProductSlider={true}
                                                currentDesignBackground={this.props.currentDesignBackground && this.props.currentDesignBackground.previews && this.props.currentDesignBackground.previews[index] ? this.props.currentDesignBackground.previews[index] : null}
                                                idx={designPageIdx + '_' + index}
                                                no_side={true}
                                                zoomScale={zoomScale}
                                            />
                                        </div>
                                        {(currentDesignBackground && currentDesignBackground.design_show_text) ? (<div
                                            className="slider-hover-desc">{currentDesignBackground.design_show_text}</div>) : null}
                                    </div>)
                                })) : null}
                            </div>
                        </div>
                    </div>
                    <Suspense fallback={<span></span>}>
                        {
                            this.props.imageUploading?<UploadModal/>:null
                        }
                    </Suspense>
                </div>)
            }}
        </ContainerDimensions>
    }
}

const mapStateToProps = state => {
    let currentDesignBackground = null;

    if (state.projectOptions && state.projectOptions.images) {
        if (state.currentProjectOptions && !Object.keys(state.currentProjectOptions).length && state.projectOptions.images.length) {
            currentDesignBackground = state.projectOptions.images[0];
        } else if (state.currentProjectOptions && state.projectOptions.images) {
            let matchIndex = state.projectOptions.images.map(image => {
                let match = 0;
                for (let option in state.currentProjectOptions) {
                    if (image[option] === state.currentProjectOptions[option]) {
                        match = match + 1;
                    }
                }
                return match;
            });

            let max = Math.max.apply(null, matchIndex);
            currentDesignBackground = state.projectOptions.images[matchIndex.findIndex(matchCount => matchCount === max)];
        }

    }
    let previewPage = 0;
    if (currentDesignBackground && currentDesignBackground.previews && state.previewPage && currentDesignBackground.previews[state.previewPage]) {
        previewPage = state.previewPage
    }

    return {
        imageUploading: state.imageUploading,
        pages: state.pages,
        currentDesignBackground: currentDesignBackground,
        previewPage: previewPage,
    }
};

const mapDispatchToProps = dispatch => ({
    goPreviewPage: (page) => dispatch(goPreviewPage(page)),
    instantUpload: (hash = null, preview_url = null, minHeight = null, minWidth = null, filterName = null) => dispatch(instantUpload(hash, preview_url, minHeight, minWidth, filterName)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductSlider);
